import axios from 'axios'

const url = 'linkdrive/plataforma/acesso-publico/anuncio'
const urlP = 'linkdrive/plataforma/acesso-privado/anuncio'

const state = {
  anuncios: [],
  anuncioIndividual: {},
  imagemAnuncio: [],
  perguntasRespostas: [],
  perguntasSemRespostas: [],
}

const getters = {
  anuncios: state => state.anuncios,
  anuncioIndividual: state => state.anuncioIndividual,
  imagemAnuncio: state => state.imagemAnuncio,
  perguntasRespostas: state => state.perguntasRespostas,
  perguntasSemRespostas: state => state.perguntasSemRespostas,
}

const mutations = {
  setAnuncios: (state, payload) => state.anuncios = payload,
  setAnuncioIndividual: (state, payload) => state.anuncioIndividual = payload,
  setImagemAnuncio: (state, payload) => state.imagemAnuncio = payload,
  setPerguntasRespostas: (state, payload) => state.perguntasRespostas = payload,
  setPerguntasSemRespostas: (state, payload) => state.perguntasSemRespostas = payload,
}

const actions = {
  async getAnuncios({ commit }) {
    const { data: anuncios } = await axios(`${url}/lista/100/pagina/1`)
    commit('setAnuncios', anuncios)
  },
  async getAnuncioIndividual({ commit }, id) {
    const { data: anuncio } = await axios(`${url}/${id}/dados-cadastrais`)
    commit('setAnuncioIndividual', anuncio[0])
  },
  async getImagemAnuncio({ commit }, id) {
    const { data: imagem } = await axios(`${url}/${id}/imagens`)
    commit('setImagemAnuncio', imagem)
  },
  async getPerguntasRespostas({ commit }, id) {
    const { data: perguntasRespostas } = await axios(`${url}/${id}/perguntas-respostas/lista/100/pagina/1`)
    commit('setPerguntasRespostas', perguntasRespostas)
  },
  async postPergunta(_, params) {
    const { id, pergunta } = params
    try {
      const response = await axios.post(`${urlP}/${id}/pergunta`, null, {
        params: { pergunta }
      });
      return response.data;
    } catch (error) {
      console.error('Error posting question:', error);
      throw error;
    }
  },
  cancelarAnuncio(_, params) {
    const { id, motivoCancelamento } = params
    return axios.put(`${urlP}/${id}/cancelar`, null, {
      params: { motivoCancelamento }
    })
  },
  async adicionarBeneficios(_, params) {
    const { id } = params
    delete params.id
    const { data: resp } = await axios.post(`${urlP}/${id}/beneficios`, params)
    return resp
  },
  async vendaAnuncioExterna(_, id) {
    const { data: resp } = await axios.put(`${urlP}/${id}/marcar-venda-externa`)
    return resp
  },
  async vendaAnuncioPlataforma(_, params) {
    const { id_anuncio, id_comprador } = params
    const { data: resp } = await axios.put(`${urlP}/${id_anuncio}/marcar-venda-plataforma/comprador/${id_comprador}`)
    return resp
  },
  async getComprador(_, email) {
    const { data: resp } = await axios(`${urlP}/buscar-comprador/${email}`)
    return resp
  },
  async getPerguntasSemResposta({ commit }, id) {
    const { data: resp } = await axios(`${urlP}/${id}/perguntas-respostas/lista/100/pagina/1`)
    const perguntasSemRespostas = resp.lista.filter(item => !item.respostas.length)
    perguntasSemRespostas.map(e => {
      e.pergunta.resposta = ''
      return e
    })
    const lista = {
      lista: perguntasSemRespostas
    }

    console.log(perguntasSemRespostas)
    commit('setPerguntasRespostas', lista)
  },

  async cadastrarRespostaPergunta(_, params) {
    const { id_anuncio, id_pergunta, resposta } = params
    const { data: resp } = await axios.post(`${urlP}/${id_anuncio}/pergunta/${id_pergunta}/resposta?resposta=${resposta}`)

    return resp
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}